import type { LoaderFunctionArgs } from "@remix-run/node";
import ProductDetail from "../components/Storefront/ProductDetail";
import prisma from "../../prisma/client";
import {
  isRouteErrorResponse,
  useLoaderData,
  useRouteError,
} from "@remix-run/react";

interface OptionValues {
  title: string;
}
[];

interface Option {
  name: string;
  optionValues: OptionValues[];
}

interface Variant {
  optionValues: string[];
  shopifyId: string;
  id: number;
  title: string;
  price: number;
  active: boolean;
  images: { src: string }[];
}

interface Product {
  id: number;
  title: string;
  description: string;
  price: number;
  imageUrl: string;
  handle: string;
  providerName: string;
  providerId: string;
  shopifyId: string;
  tags: string[];
  store: {
    name: string;
    id: number;
    description: string | null;
    handle: string;
    createdAt: Date;
    updatedAt: Date;
    owner: {
      id: number;
      name: string;
    };
    state: string;
  };
  variants: Variant[];
  options: Option[];
}

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const product = await prisma.product.findFirst({
    where: {
      handle: params.productHandle as string,
      store: {
        handle: params.handle as string,
      },
      approved: true,
      active: true,
    },
    include: {
      store: {
        include: {
          owner: true,
        },
      },
      variants: {
        where: {
          active: true,
        },
        include: {
          images: {
            orderBy: {
              id: "asc",
            },
          }
        },
      },
      options: {
        include: {
          optionValues: true,
        },
      },
    },
  });

  if (!product) {
    throw new Response("Product not found", { status: 404 });
  }

  return { product };
};

export default function Storefront() {
  const { product } = useLoaderData<{ product: Product }>();
  
  return (
    <>
      <div className="pt-20 bg-white">
        <ProductDetail product={product} />
      </div>
      <script
        defer
        src="https://cloud.umami.is/script.js"
        data-website-id="e7b03ef1-5d1b-4bf6-b1aa-2fa7b37eb5fe"
      ></script>
    </>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div className="pt-20">
        <h1 className="text-4xl text-center py-10">
          {error.status} {error.statusText} {error.data}
        </h1>
      </div>
    );
  }
}
